import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { SubOrderService } from '../../services';
import { SUB_ORDERS_LIST_KEY, SUB_ORDERS_ONE_KEY } from '../../constants/sub-order.queries';
import { DISPATCH_SUB_ORDER_LIST_KEY } from 'modules/sales/common/constants/order-query';
import { useDispatchDetail } from 'modules/sales/dispatch/contexts/dispatchContext';
import { useOrderContext } from 'modules/sales/common/contexts/OrderContext';
import { PAID_ORDERS_ONE_KEY } from 'modules/sales/paid-order/constants';

const useSubOrderStatusUpdate = (orderId: string) => {
  const { t } = useTranslation(['subOrder', 'errors']);
  const { dispatch } = useDispatchDetail();
  const { order } = useOrderContext();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation((status: string) => SubOrderService.updateStatus(orderId, status), {
    onSuccess: ({ data }: any) => {
      toast.success(t('subOrder:successStatusUpdate'));
      queryClient.invalidateQueries({ queryKey: [SUB_ORDERS_LIST_KEY] });
      queryClient.invalidateQueries({ queryKey: [orderId, SUB_ORDERS_ONE_KEY] });
      dispatch?._id && queryClient.invalidateQueries({ queryKey: [dispatch?._id, DISPATCH_SUB_ORDER_LIST_KEY] });
      order?._id && queryClient.invalidateQueries({ queryKey: [order?._id, PAID_ORDERS_ONE_KEY] });
    },
    onError: (error: { reference: string }) => {
      let errorMessage = 'generalErrorMessage';
      if (error?.reference) {
        errorMessage = `subOrder:errors.${error?.reference}`;
      }
      toast.error(t(errorMessage, { ns: 'errors' }));
    },
  });

  return {
    updateStatus: mutateAsync,
    isLoading,
  };
};

export default useSubOrderStatusUpdate;
